import React from 'react'

import { Router } from 'routes'

export const App: React.FC = () => {
  return <Router />
}
